<template>
  <div class="dataTables_wrapper dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="col-xs-12 text-left form-group">
          <div class="btn btn-default btn-table-title" @click="crElement()">新增{{tabName}}圖示</div>
          <button :disabled="!selectItems.length" class="btn btn-danger btn-table-title" data-toggle="modal" data-target="#delModal" @click="setDeleteModal()">批次刪除</button>
          <button v-if="getRoleType !== 10 || getStores.length > 1" :disabled="!selectItems.length" class="btn btn-default btn-table-title" data-toggle="modal" data-target="#copyModal">複製選取設定至其他店家</button>
        </div>
        <!--
        <div class="form-group">
          <select class="form-control h-38" v-model="selectActive">
            <option value="99">全部</option>
            <option value="1">啟用</option>
            <option value="0">停用</option>
          </select>
        </div>
        -->
      </div>
      <div class="col-sm-6 text-right form-inline">
        <div class="form-group">
          <select v-model="searchType" class="form-control h-38">
            <option value="name">商品名稱</option>
            <option value="id">商品料號</option>
          </select>
        </div>
        <div class="form-group search-bar">
          <div class="input-group">
            <input v-if="searchType === 'name'" class="form-control" type="text" v-model="searchInput.name">
            <input v-if="searchType === 'id'" class="form-control" type="text" v-model="searchInput.id">
            <span class="input-group-addon c-pointer" @click="search"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""><input type="checkbox" v-model="checkBoxSelectAll" @change="selectAll" /></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">小圖</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">商品名稱</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">商品料號</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">啟用</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="tab !== 10">大圖</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
          </tr>
          </thead>
          <tbody v-if="imgList.length">
            <tr class="even" role="row" v-for="(img, index) in imgList">
              <!-- cloumn 0 -->
              <td><input type="checkbox" v-model="img.selectItem" /></td>
              <td class="sorting_1">{{index + 1}}</td>
              <!-- column 1-->
              <td>
                <div><img class="img img-responsive" :src="img.main_image.img_url"></div>
              </td>
              <td>
                <div>{{img.product_name}}</div>
              </td>
              <td>
                <div>{{img.vendor_custom_id}}</div>
              </td>
              <td>
                <label class="label label-success" v-if="img.is_enabled">啟用</label>
                <label class="label label-danger" v-else>停用</label>
              </td>
              <td v-if="tab !== 10">
                <div class="inline-block" v-for="bigImg in img.sub_image_list">
                  <img class="img img-responsive" :src="bigImg.img_url" style="height: 30px">
                </div>
              </td>
              <td>
                <button class="btn btn-primary" @click="upElement(img.id)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              </td>
              <td>
                <button class="btn btn-danger" data-toggle="modal" data-target="#delModal" @click="clickCurrent(img.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr style="background-color: white">
              <td rowspan="1" colspan="9" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                :groupAmount="groupAmount" :clickPage="clickPage"
      >
      </paginate>
    </div>
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
    <choose-store-modal @copyStore="copyStore" :option="storeOption"></choose-store-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import matcherModal from '../../../elements/Modal.vue'
import chooseStoreModal from '@/components/elements/chooseStoreModal.vue'

export default{
  props: {
    imgList: Array,
    imgMeta: Object,
    tab: Number,
    getProductImageList: Function
  },
  components: {
    'm-modal': matcherModal,
    'choose-store-modal': chooseStoreModal
  },
  data () {
    return {
      query: {},
      querySearch: {
        type: '',
        val: ''
      },
      prodImgList: [],
      selectActive: 99,
      searchType: 'name',
      searchInput: {
        name: '',
        id: ''
      },
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 0,
      count: 20,
      delOption: {
        id: 'delModal',
        title: '刪除綁定',
        body: '刪除綁定，此處刪除等同刪除該項目所有關聯！<br>刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delBind'
          }
        ]
      },
      storeOption: {
        id: 'copyModal'
      },
      curId: 0,
      checkBoxSelectAll: false
    }
  },
  methods: {
    selectAll () {
      this.imgList = this.imgList.map(x => {
        return {
          ...x,
          selectItem: this.checkBoxSelectAll
        }
      })
    },
    deleteSelectItem () {
      if (!this.selectItems.length) return
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/batchDelete?setting_ids=' + this.selectItems.toString()
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.getProductImageList()
        }
      })
    },
    setDeleteModal () {
      this.delOption.btns[1].event = 'batchDelete'
    },
    search () {
      this.querySearch.type = this.searchType
      this.querySearch.val = this.searchInput[this.searchType]
      this.clickPage(1)
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    delModalOpen (img) {
      this.delOption.title = '刪除' + img.name + '綁定'
      this.curId = img.item_id
    },
    trigger (event) {
      if (event === 'delBind') {
        this.delBind()
      } else if (event === 'batchDelete') {
        this.deleteSelectItem()
      }
    },
    clickCurrent (id) {
      this.delOption.btns[1].event = 'delBind'
      this.curId = id
    },
    delBind () {
      var self = this
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/' + this.curId
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.curId = 0
          self.getProductImageList()
        }
      })
    },
    upElement (settingId) {
      const bId = this.$route.params.brand_id
      const sId = this.$route.params.store_id
      switch (this.tab) {
        case 1:
          this.$router.push({path: `/upProductImg/${bId}/${sId}/${settingId}`, query: this.query})
          break
        case 3:
          this.$router.push({path: `/upPackageImg/${bId}/${sId}/${settingId}`, query: this.query})
          break
        case 10:
          this.$router.push({path: `/upCategoryImg/${bId}/${sId}/${settingId}`, query: this.query})
          break
      }
    },
    crElement () {
      const bId = this.$route.params.brand_id
      const sId = this.$route.params.store_id
      console.log(this.query)
      switch (this.tab) {
        case 1:
          this.$router.push({path: `/crProductImg/${bId}/${sId}`, query: this.query})
          break
        case 3:
          this.$router.push({path: `/crPackageImg/${bId}/${sId}`, query: this.query})
          break
        case 10:
          this.$router.push({path: `/crCategoryImg/${bId}/${sId}`, query: this.query})
          break
      }
    },
    isActive (index) {
      if (Number(this.tableIndex) === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      var query = this.$route.query
      if (query) {
        query = {
          ...query,
          page: index
        }
      } else {
        query = {
          page: index
        }
      }
      this.$router.push({query: query})
      this.getProductImageList(index, this.querySearch.type, this.querySearch.val)
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    copyStore (storeList) {
      // 同步多門市商品圖片設定
      if (storeList.length) {
        const url = `/store/${this.$route.params.store_id}/productImageSetting/storeSync`
        const data = {
          store_id_list: storeList,
          setting_id_list: this.selectItems,
          type: this.tab
        }
        this.getDataH('post', url, data, (response) => {
          if (response.data.status === 200) {
            this.$notify({
              title: '複製成功',
              duration: 3000,
              type: 'success',
              width: 400
            })
            // clear select
            this.imgList.forEach(element => {
              element.selectItem = false
            })
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getStores']),
    tabName () {
      switch (this.tab) {
        case 2: return '配料'
        case 20: return '配料群組'
        case 10: return '商品分類'
        case 1: return '商品'
        case 11: return '品項選擇區'
        case 3: return '套餐'
      }
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    selectItems () {
      // 選擇的項目
      return this.imgList.filter(x => x.selectItem).map(x => x.id)
    }
  },
  created () {
    if (this.$route.query.brand_name && this.$route.query.store_name) {
      this.query = {
        brand_name: this.$route.query.brand_name,
        stroe_name: this.$route.query.store_name
      }
    }
    console.log(this.query)
  },
  watch: {
    selectActive () {
      this.tableIndex = 1
      this.searchInput.name = ''
      this.searchInput.id = ''
    },
    tab () {
      this.searchInput.name = ''
      this.searchInput.id = ''
      this.querySearch.type = ''
      this.querySearch.val = ''
      var page = this.$route.query.page || 1
      this.tableIndex = page
      this.checkBoxSelectAll = false
    },
    imgMeta () {
      this.total = this.imgMeta.total
      this.count = this.imgMeta.size
    }
  },
  mounted () {
    var page = this.$route.query.page || 1
    this.tableIndex = page
    this.prodImgList = this.imgList
  }
}
</script>
<style lang="sass">
  .img-ad-table
    height: 50px
</style>



// WEBPACK FOOTER //
// ProdImgTable.vue?a9b1a3dc